export default __webpack_public_path__ + "static/media/diva.ac9fc791.png";